import polyfill from "./polyfill"
import readMore from "./js/read-more"
import countdown from "./js/countdown"
import carousel from "./js/carousel"

export default function init() {
  polyfill()
  readMore()
  countdown()
  carousel()
}
